/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

const FEATURE_MAP = {
  exercise_flag:   { label: '깃발게임',        color: '#f59e0b' },
  exercise_head:   { label: '손바닥피하기',     color: '#f59e0b' },
  exercise_grab:   { label: '사과잡기',         color: '#f59e0b' },
  training_color:  { label: '색상찾기',         color: '#ef4444' },
  training_number: { label: '숫자훈련',         color: '#ef4444' },
  training_piano:  { label: '소리게임',         color: '#ef4444' },
  ai_draw:         { label: '말하는대로그리기',  color: '#ec4899' },
  ai_mirror:       { label: '젊어지는거울',     color: '#ec4899' },
  ai_voice:        { label: 'AI 음성변조',      color: '#ec4899' },
  learn_listen:    { label: '듣기훈련',         color: '#10b981' },
  learn_read:      { label: '읽기훈련',         color: '#10b981' },
  learn_write:     { label: '쓰기훈련',         color: '#10b981' },
};

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px', fontSize: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
      <p style={{ fontWeight: 'bold', margin: '0 0 4px' }}>{d.label}</p>
      <p style={{ margin: 0 }}>이용 횟수: {d.count}회</p>
    </div>
  );
};

const PiCareBarChartUsage = () => {
  const { featureCount, loading } = useSelector((state) => state.picareDashboard);

  const data = useMemo(
    () =>
      featureCount
        .map((item) => {
          const meta = FEATURE_MAP[item._id];
          if (!meta) return null;
          return {
            id: item._id,
            label: meta.label,
            count: item.startCount,
            color: meta.color,
          };
        })
        .filter((item) => item && item.count > 0),
    [featureCount],
  );

  if (loading.featureCount) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart layout="vertical" data={data} margin={{ top: 4, right: 16, left: 0, bottom: 4 }}>
        <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
        <YAxis dataKey="label" type="category" width={110} tick={{ fontSize: 11 }} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0,0,0,0.04)' }} />
        <Bar dataKey="count" name="이용 횟수" radius={[0, 4, 4, 0]}>
          {data.map((entry) => (
            <Cell key={entry.id} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default PiCareBarChartUsage;
